import { gql } from 'apollo-angular'

export const GET_USER_ARTICLE_PURCHASE_BY_ID = gql`
  query getUserArticlePurchaseById($id: Int!) {
    UserArticlePurchase(id: $id) {
      id
      paid_at
      purchase_price
      tax_percentage
      article {
        id
        title
      }
    }
  }
`
